/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Search,
  Search$inboundSchema,
  Search$Outbound,
  Search$outboundSchema,
} from "./search.js";

export type SearchStep = {
  type?: "base_search" | undefined;
  think: string;
  currentQuestion: string;
  errored?: boolean | undefined;
  search: Search;
};

/** @internal */
export const SearchStep$inboundSchema: z.ZodType<
  SearchStep,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("base_search").default("base_search"),
  think: z.string(),
  current_question: z.string(),
  errored: z.boolean().default(false),
  search: Search$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "current_question": "currentQuestion",
  });
});
/** @internal */
export type SearchStep$Outbound = {
  type: "base_search";
  think: string;
  current_question: string;
  errored: boolean;
  search: Search$Outbound;
};

/** @internal */
export const SearchStep$outboundSchema: z.ZodType<
  SearchStep$Outbound,
  z.ZodTypeDef,
  SearchStep
> = z.object({
  type: z.literal("base_search").default("base_search" as const),
  think: z.string(),
  currentQuestion: z.string(),
  errored: z.boolean().default(false),
  search: Search$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    currentQuestion: "current_question",
  });
});

export function searchStepToJSON(searchStep: SearchStep): string {
  return JSON.stringify(SearchStep$outboundSchema.parse(searchStep));
}
export function searchStepFromJSON(
  jsonString: string,
): SafeParseResult<SearchStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchStep' from JSON`,
  );
}
